module.exports = __webpack_public_path__ + "static/media/notosans-light.2a6e667a.woff";